<rt-dropdown [width]="DropdownWidth.FullWidth">
  <div #dropdownContainer rtScrollable [style.maxHeight]="maxHeight + 'px'" class="dropdown">
    <rt-dropdown-item
      #itemsQuery
      *ngFor="let option of options; let last = last; trackBy: trackByOption"
      [class.active]="option.value === currentOption?.value"
      [noDivider]="last"
      (click)="onSelect(option)"
      class="dropdown-item"
    >
      {{ option.label }}
    </rt-dropdown-item>
  </div>
</rt-dropdown>
